import React from 'react';
import { FormattedMessage } from 'react-intl';
import { MatrixFilters } from './components/MatrixFilters/MatrixFilters';
import { MatrixTable } from './components/MatrixTable/MatrixTable';
import { useVatRatesMatrixVM } from './VatRatesMatrix.viewmodel';
import { ErrorMessage, LoadingContainer, PageContainer, Subtitle, Title } from './VatRatesMatrix.style';

const VatRatesMatrix: React.FunctionComponent = () => {
    const {
        isLoading,
        error,
        operationZones,
        vatGroups,
        uniqueZoneCodes,
        allGroups,
        zoneFilter,
        setZoneFilter,
        groupFilter,
        setGroupFilter,
        modeFilter,
        setModeFilter,
        exportCsv,
        exportError,
    } = useVatRatesMatrixVM();

    if (isLoading) {
        return (
            <LoadingContainer>
                <FormattedMessage id="vatRatesMatrix.loading" />
            </LoadingContainer>
        );
    }

    if (error) {
        return (
            <PageContainer>
                <FormattedMessage id="vatRatesMatrix.error" />
            </PageContainer>
        );
    }

    return (
        <PageContainer>
            <Title>
                <FormattedMessage id="vatRatesMatrix.title" />
            </Title>
            <Subtitle>
                <FormattedMessage id="vatRatesMatrix.subtitle" />
            </Subtitle>
            <MatrixFilters
                zones={uniqueZoneCodes}
                groups={allGroups}
                zoneFilter={zoneFilter}
                onZoneFilterChange={setZoneFilter}
                groupFilter={groupFilter}
                onGroupFilterChange={setGroupFilter}
                modeFilter={modeFilter}
                onModeFilterChange={setModeFilter}
                onExportCsv={exportCsv}
            />
            {exportError && (
                <ErrorMessage>
                    <FormattedMessage id="vatRatesMatrix.exportError" />
                </ErrorMessage>
            )}
            <MatrixTable operationZones={operationZones} vatGroups={vatGroups} modeFilter={modeFilter} />
        </PageContainer>
    );
};

export default VatRatesMatrix;
